define('helperComponent-getContent',['require','helperComponent-getContentArray','helperComponent-parseContent'],function(require) {
    'use strict';

    var getContentArray = require('helperComponent-getContentArray'),
        parseContent = require('helperComponent-parseContent');

    var getContent = function(componentsJSON, kind) {
        var arr = getContentArray(componentsJSON, kind),
            res = {},
            content = {};

        if (!Array.isArray(arr) || !arr.length) {
            return {};
        }

        if (arr.length === 1) {
            return parseContent(arr[0]);
        }

        for (var i = 0; i < arr.length; i++) {
            content = parseContent(arr[i]);

            for (var key in content) {
                if (res.hasOwnProperty(key)) {
                    res[key].push(content[key]);
                } else {
                    res[key] = [content[key]];
                }
            }
        }

        return res;
    };

    return getContent;
});

